import { DateFormatter, DuplicateBanner } from '@components'

import { Badge, Flex, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getAttachmentEInvoiceTypeBadge } from '@features/eInvoicing/utils/getAttachmentEInvoiceTypeBadge'

import { useAttachmentPreviewModal } from '../../../../context/attachmentPreviewModalContext'
import { AttachmentInfo } from '../AttachmentInfo'
import { EInvoiceBlockedBanner } from '../EInvoiceBlockedBanner'

export const FileDetails = (): ReactElement => {
  const {
    attachment,
    close,
    createdDate,
    fileName,
    isDuplicate,
    isEInvoicingOnly,
    isShoeboxReadOnly,
    onOpenDuplicate,
  } = useAttachmentPreviewModal()
  const { t } = useTranslation()
  const typeBadge = attachment
    ? getAttachmentEInvoiceTypeBadge({ attachment, isEInvoicingOnly, isShoeboxReadOnly })
    : undefined

  return (
    <Flex flexDirection="column">
      {isDuplicate && (
        <DuplicateBanner
          onPress={() => {
            close()
            if (attachment?.id) {
              onOpenDuplicate?.(attachment.id)
            }
          }}
        />
      )}
      {typeBadge && !isEInvoicingOnly && (
        <>
          <Flex>
            <Badge color={typeBadge.color} mode="subtle">
              {t(typeBadge.labelKey)}
            </Badge>
          </Flex>
          <Space size="s16" />
        </>
      )}
      {typeBadge && isEInvoicingOnly && <EInvoiceBlockedBanner attachment={attachment} typeBadge={typeBadge} />}
      <Text weight="bold">{t('attachment_preview_modal.details.file_subtitle')}</Text>
      <Space size="s4" />
      <AttachmentInfo title={t('attachment_preview_modal.details.filename_label')}>
        <Text>{fileName}</Text>
      </AttachmentInfo>
      <AttachmentInfo title={t('attachment_preview_modal.details.upload_date_label')}>
        <Text>{createdDate ? <DateFormatter value={createdDate} /> : '-'}</Text>
      </AttachmentInfo>
    </Flex>
  )
}
